// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3qmb0","tablePagination":"Table_tablePagination__1kl9Z","rowName":"Table_rowName___RGCz","inset":"Table_inset__36s7-","tableRow":"Table_tableRow__5gBAN"};